module.exports = __webpack_public_path__ + "static/media/naturgy.54d3d39e.svg";